module.exports = __webpack_public_path__ + "img/eye-in-client-king-tours.ec96c49b.png";